import React from 'react';
import styled from '@emotion/styled';
import { FormattedTime, ITheme, VisuallyHidden } from '../../../../../ui';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import themed from '../../../../../ui/themer/themed';

const StyledScheduledTime = styled.span<{}, ITheme>`
	font-weight: 700;
	white-space: nowrap;

	s {
		position: relative;
		text-decoration: none;
		white-space: nowrap;

		&:after {
			content: '';
			position: absolute;
			top: 50%;
			left: 0;
			width: 100%;
			height: 3px;
			background: ${themed(({ color }) => color.state.error)};
			transform: translateY(-50%);
		}
	}

	em {
		color: ${themed(({ color }) => color.state.error)};
		font-style: normal;
	}
`;

interface IScheduledTimeProps {
	arrival: boolean;
	isDelayed: boolean;
	scheduledTimestamp: number;
	bestKnownTimestamp: number;
}

export const ScheduledTime = ({
	arrival,
	isDelayed,
	scheduledTimestamp,
	bestKnownTimestamp,
}: IScheduledTimeProps) => {
	const { t } = useTranslation();
	return (
		<>
			{isDelayed && !arrival ? (
				<StyledScheduledTime>
					<s>
						<VisuallyHidden>{t('flight_time_original_time')}</VisuallyHidden>
						<FormattedTime value={scheduledTimestamp} />
					</s>
					<br />
					<em>
						<VisuallyHidden>{t('flight_time_delayed_time')}</VisuallyHidden>
						<FormattedTime value={bestKnownTimestamp} />
					</em>
				</StyledScheduledTime>
			) : (
				<StyledScheduledTime>
					<FormattedTime value={scheduledTimestamp} />
				</StyledScheduledTime>
			)}
		</>
	);
};
